import { IBreadCrumb } from './bread-crump/model/ibread-crumb';
import { NavigationExtras, Router } from '@angular/router';
import { AppConfigService } from '../services/AppConfigService';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Params } from 'express-serve-static-core';
import { DateType } from 'ngx-hijri-gregorian-datepicker';
import { CurrentUserDto } from '../models/current-user.model';
import { Roles } from '../models/roles.enum';
import domtoimage from 'dom-to-image';
import jspdf, { jsPDF } from 'jspdf';

import jwt_decode from 'jwt-decode';
import { TableColumnConfig } from './list/table.columns';
import { AttachementService } from '../services/attachement';
import * as FileSaver from 'file-saver';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { UserTaskCountDto } from '../models/user';
import { CurrentUserService } from '../services/current-user.service';
import { AuthService } from '../services/authentication/auth.service';
import { AjaxInterceptorService } from '../interceptors/AjaxInterceptorService';
import { SystemRoles } from '../services/authentication/roleEnum';
import html2canvas from 'html2canvas';
import { CacheService } from '../services/cashe-service';
import { Guid } from 'guid-typescript';

@Component({ // create seletor base for test override property
    selector: 'base-component',
    template: ``
})
export class BaseComponent {
    pageSize: number = environment.defaultPageSize;
    breadcrumbItems?: IBreadCrumb[];
    tableColumnConfigs: TableColumnConfig[];
    selectedDateType = DateType.Gregorian;
    public currentUserName: string;
    public currentUserRoles: string[];
    public currentCulture: string;
    public isAuthenticated: boolean = false;
    public isAzureAuthenticated: boolean = false;
    public showLoader: boolean = false;
    public isArabic: boolean = true;
    public userTaskCount: UserTaskCountDto;
    dropdownSettings: IDropdownSettings = {};

    constructor(
        public currentUserService?: CurrentUserService,
        public authService?: AuthService,
        public router?: Router,
        public attachementService?: AttachementService,
        public translate?: TranslateService,
        public rendererr?: Renderer2,
        public ajaxInterceptorService?: AjaxInterceptorService) {
        //this.loadAllScripts();
            this.initGlobalVariables();
        
        // this.loadAllScripts();
        // this.initGlobalDropdownSettings();
        // this.loadJs();
        // this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
        //     this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
        //     this.loadScript('assets/myUI/app-assets/js/core/app.js');
        // setTimeout(() => {
            
        // }, 500); // Delay to ensure DOM is ready
    }


    
     // Load scripts in order
//   loadAllScripts() {
//     try {
//       this.loadScript('assets/myUI/js/jquery.js');

//       // this.loadScript('assets/myUI/app-assets/js/core/app.js');

//       setTimeout(() => {
//         this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
//       }, 100); // Delay to ensure DOM is ready
//       setTimeout(() => {
//         this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
//         // this.loadScript('assets/myUI/app-assets/js/core/app.js');

//       }, 300); // Delay to ensure DOM is ready
//       setTimeout(() => {
//         //this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
//         this.loadScript('assets/myUI/app-assets/js/core/app.js');

//       }, 700); // Delay to ensure DOM is ready
//       console.log('✅ All scripts loaded successfully!');

//       window.onload = () => {
//         console.log('✅ All scripts and assets have loaded.');
//       };
//     } catch (error) {
//       console.error('❌ Error loading scripts:', error);
//     }


//   }

  loadScript2(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // if (!window['$']) {
      //   console.error('❌ jQuery is not loaded yet.');
      //   reject();
      //   return;
      // }

      const script = this.rendererr.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      script.defer = true;

      script.onload = () => {
        console.log(`✅ Loaded: ${src}`);
        resolve();
      };

      script.onerror = () => {
        console.error(`❌ Failed to load: ${src}`);
        reject();
      };

      this.rendererr.appendChild(document.body, script);
    });
  }
    // loadScript(src: string): void {
    //     const script = this.rendererr.createElement('script');
    //     script.src = src;
    //     script.type = 'text/javascript';
    //     script.defer = true;
    //     this.rendererr.appendChild(document.body, script);
    //   }
    generateGUID = (): string => {
        return Guid.create().toString();
        //return crypto.randomUUID();
    };
    changeLanguage(lang) {
        localStorage.setItem('lang', lang);
        location.href = location.href;
    }
    initGlobalDropdownSettings() {
        this.dropdownSettings = {
            singleSelection: true,
            idField: 'value',
            textField: 'text',
            selectAllText: this.isArabic ? 'اختر الكل' : 'Select All',
            unSelectAllText: this.isArabic ? 'إلغاء اختيار الكل' : 'Deselect All',
            searchPlaceholderText: this.isArabic ? 'بحث' : 'Search',
            noFilteredDataAvailablePlaceholderText: this.isArabic ? 'لا توجد بيانات' : 'No Data Found',
            itemsShowLimit: 10,
            allowSearchFilter: true
        };
    }
    // public loadCSS(href: string): void {
    //     const link = this.renderer.createElement('link');
    //     link.rel = 'stylesheet';
    //     link.href = href;
    //     this.renderer.appendChild(document.head, link);
    //   }

    //   public loadJS(src: string): void {
    //     const script = this.renderer.createElement('script');
    //     script.type = 'text/javascript';
    //     script.src = src;
    //     script.defer = true;
    //     this.renderer.appendChild(document.body, script);
    //   }
    NavigateToCompanyProfile(form: FormGroup) {
        var comp = form.get('CompanyProfileId');
        // this.router.navigateByUrl("services/companies/" + comp.value);
        this.router.navigateByUrl('');
    }

    NavigateToHome() {
        this.router.navigateByUrl('');
    }
    ngOnInit() {

// this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
//             this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
//             this.loadScript('assets/myUI/app-assets/js/core/app.js');

    }




    scripts = [
        'assets/myUI/js/jquery.js',
        'assets/myUI/app-assets/vendors/js/vendors.min.js',
        'assets/myUI/app-assets/js/core/app-menu.js',
        'assets/myUI/app-assets/js/core/app.js'
      ];
      loadScript(src: string): Promise<void> {
        return new Promise((resolve, reject) => {
          // if (!window['$']) {
          //   console.error('❌ jQuery is not loaded yet.');
          //   reject();
          //   return;
          // }
      
          const script = this.rendererr.createElement('script');
          script.src = src;
          script.type = 'text/javascript';
          script.defer = true;
      
          script.onload = () => {
            console.log(`✅ Loaded: ${src}`);
            resolve();
          };
      
          script.onerror = () => {
            console.error(`❌ Failed to load: ${src}`);
            reject();
          };
      
          this.rendererr.appendChild(document.body, script);
        });
      }
      
        // Load scripts in order
        loadAllScripts() {
          try {
            this.loadScript(this.scripts[0])
            .then(() => this.loadScript(this.scripts[1]))
            .then(() => this.loadScript(this.scripts[2]))
            .then(() => this.loadScript(this.scripts[3]))
            .then(() => console.log('All scripts loaded successfully'))
            .catch(error => console.error('Script loading error:', error));
      
      
      
            // this.loadScript('assets/myUI/js/jquery.js');
            // setTimeout(() => {
            //   this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
            // }, 100); // Delay to ensure DOM is ready
            // setTimeout(() => {
            //   this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
            //   // this.loadScript('assets/myUI/app-assets/js/core/app.js');
      
            // }, 300); // Delay to ensure DOM is ready
            // setTimeout(() => {
            //   //this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
            //   this.loadScript('assets/myUI/app-assets/js/core/app.js');
            // }, 700); // Delay to ensure DOM is ready
        
            window.onload = () => {
              console.log('✅ All scripts and assets have loaded.');
            };
          } catch (error) {
            console.error('❌ Error loading scripts:', error);
          }
      
      
        }





    initGlobalVariables() {
        this.setCurrentCulture();
    }
    public get Roles(): typeof SystemRoles {
        return SystemRoles;
    }
    public RoleName(Role: SystemRoles): string {
        return SystemRoles[Role];
    }
    IsAuthorize(roles: Array<string>): boolean {
        return this.authService.IsAuthorize(roles);
    }

    done(message: string) {
        this.translate.get(message).subscribe((data: any) => {
            Swal.fire({
                icon: 'success',
                text: data,
                confirmButtonText: this.translate.instant('shared.ok'),
                customClass: {
                    confirmButton: 'submit btn primary-btn',
                    // ,cancelButton: 'btn primary-outline-btn'
                }
            });
        });
    }

    doneWithParameter(message: string, parameter?: string) {
        this.translate.get(message, parameter).subscribe((data: any) => {
            Swal.fire({
                icon: 'success',
                html: data,
                confirmButtonText: this.translate.instant('shared.ok'),
                customClass: {
                    confirmButton: 'submit btn primary-btn',
                    // ,cancelButton: 'btn primary-outline-btn'
                }
            });
        });
    }

    failed(message: string) {
        this.translate.get(message).subscribe((data: any) => {
            Swal.fire({
                icon: 'error',
                text: data,
                confirmButtonText: this.translate.instant('shared.ok'),
                customClass: {
                    confirmButton: 'submit btn primary-btn',
                    // ,cancelButton: 'btn primary-outline-btn'
                }
            });
        });
    }

    info(message: string) {
        this.translate.get(message).subscribe((data: any) => {
            Swal.fire({
                icon: 'info',
                text: data,
                confirmButtonText: this.translate.instant('shared.ok'),
                customClass: {
                    confirmButton: 'submit btn primary-btn',
                    // ,cancelButton: 'btn primary-outline-btn'
                }
            });
        });
    }
    confirm(message?: string) {
        let title = message ? this.translate.instant(message) : this.translate.instant('shared.areYouSure');

        return Swal.fire({
            title: title,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: this.translate.instant('shared.cancel'),
            confirmButtonText: this.translate.instant('shared.yes'),
            customClass: {
                confirmButton: 'submit btn primary-btn',
                cancelButton: 'btn primary-outline-btn'
            }
        });
    }


    noWhitespaceValidator(control: FormControl) {
        if (control?.value) {
            const isWhitespace = (control?.value || '').trim()?.length === 0;
            const isValid = !isWhitespace;
            return isValid ? null : {
                whitespace: true
            };
        }
        return { whitespace: false };
    }

    public toLowerParams(params: Params): Params {
        const lowerParams: Params = {};
        for (const key in params) {
            lowerParams[key.toLowerCase()] = params[key];
        }
        return lowerParams;
    }

    getDecodedAccessToken(token: string): any {
        try {
            return jwt_decode(token);
        } catch (Error) {
            return null;
        }
    }
    // getUserTasksCount() {
    //     this.currentUserService.getUserTasksCount().subscribe(
    //         (data: ApiResponse<UserTaskCountDto>) => {
    //             this.userTaskCount = data.value;
    //         });
    // }

    convetToPDF(divId, fileName) {

        var data = document.getElementById(divId);
        html2canvas(data).then(canvas => {
            // Few necessary setting options
            var imgWidth = 208;
            var pageHeight = 295;
            var imgHeight = canvas.height * imgWidth / canvas.width;
            // var imgHeight = (((canvas.height * imgWidth) )/ canvas.width)+40;
            var heightLeft = imgHeight;

            const contentDataURL = canvas.toDataURL('image/png')
            let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
            var position = 0;
            pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
            pdf.save(fileName + '.pdf'); // Generated PDF
        });
    }
    setCurrentCulture() {
        let lang = localStorage.getItem('lang');
        this.currentCulture = lang == 'ar' ? 'ar-SA' : 'en-US';
        this.isArabic = lang == 'ar' ? true : false;
    }

    pagedItems: any[];
    getPagedData(pageNumber, items) {
        let startIndex = (pageNumber - 1) * this.pageSize;
        this.pagedItems = items?.slice(startIndex, startIndex + this.pageSize);
        this.loadTblHeadersJs();
    }

    download(id) {
        this.attachementService.download(id).subscribe((result: any) => {
            if (result.value) {
                const byteCharacters = atob(result.value.attachmentContent.fileContent);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const file = new Blob([byteArray], { type: result.value.contentType });
                FileSaver.saveAs(file, result.value.fileName);
            }
        });
    }

    loadJs() {
        const element = document.getElementById('customScriptFile');
        if (element)
            element.remove();


        var customScriptFile = document.createElement('script');
        customScriptFile.type = 'text/javascript';
        customScriptFile.src = 'assets/myUI/app-assets/js/scripts/pages/dashboard-ecommerce.js';
        customScriptFile.id = 'customScriptFile';
        document.body.appendChild(customScriptFile);
    }

    loadTblHeadersJs() {
        const element = document.getElementById('dataTableHeadersFile');
        if (element)
            element.remove();


        var dataTableHeadersFile = document.createElement('script');
        dataTableHeadersFile.type = 'text/javascript';
        dataTableHeadersFile.src = '/assets/js/dataTableHeaders.js';
        dataTableHeadersFile.id = 'customScriptFile';
        document.body.appendChild(dataTableHeadersFile);
    }

    loadHijriGregorianDatepickerJs() {
        const element = document.getElementById('hijriGregorianDatepickerFile');
        if (element)
            element.remove();


        var hijriGregorianDatepickerFile = document.createElement('script');
        hijriGregorianDatepickerFile.type = 'text/javascript';
        hijriGregorianDatepickerFile.src = '/assets/js/hijri-gregorian-datepicker.js';
        hijriGregorianDatepickerFile.id = 'hijriGregorianDatepickerFile';
        document.body.appendChild(hijriGregorianDatepickerFile);
    }

    librarySwiperJs() {
        const element = document.getElementById('librarySwiperFile');
        if (element)
            element.remove();


        var librarySwiperFile = document.createElement('script');
        librarySwiperFile.type = 'text/javascript';
        librarySwiperFile.src = '/assets/js/librarySwiper.js';
        librarySwiperFile.id = 'librarySwiperFile';
        document.body.appendChild(librarySwiperFile);
    }

    researcherSwiperJs() {
        const element = document.getElementById('researcherFile');
        if (element)
            element.remove();


        var researcherSwiperFile = document.createElement('script');
        researcherSwiperFile.type = 'text/javascript';
        researcherSwiperFile.src = '/assets/js/researcherSwiper.js';
        researcherSwiperFile.id = 'researcherSwiperFile';
        document.body.appendChild(researcherSwiperFile);
    }

    loadTelephoneJs() {
        const element = document.getElementById('telephoneJsFile');
        if (element)
            element.remove();


        var telephoneJsFile = document.createElement('script');
        telephoneJsFile.type = 'text/javascript';
        telephoneJsFile.src = '/assets/js/telephoneDropdown.js';
        telephoneJsFile.id = 'customScriptFile';
        document.body.appendChild(telephoneJsFile);
    }
    loadToolTipJs() {
        const element = document.getElementById('toolTipJsFile');
        if (element)
            element.remove();

        var toolTipJsFile = document.createElement('script');
        toolTipJsFile.type = 'text/javascript';
        toolTipJsFile.src = '/assets/js/toolTip.js';
        toolTipJsFile.id = 'customScriptFile';
        document.body.appendChild(toolTipJsFile);
    }

    loadTimePickerJs() {
        const element = document.getElementById('timePickerJsFile');
        if (element)
            element.remove();


        var timePickerJsFile = document.createElement('script');
        timePickerJsFile.type = 'text/javascript';
        timePickerJsFile.src = '/assets/js/timepicker.js';
        timePickerJsFile.id = 'customScriptFile';
        document.body.appendChild(timePickerJsFile);
    }



    GetCurrentDate() {
        var d = new Date();
        var datestring =
            ('0' + d.getDate()).slice(-2) +
            '-' +
            ('0' + (d.getMonth() + 1)).slice(-2) +
            '-' +
            d.getFullYear() +
            ' ' +
            ('0' + d.getHours()).slice(-2) +
            ':' +
            ('0' + d.getMinutes()).slice(-2) +
            ':' +
            ('0' + d.getSeconds()).slice(-2) +
            ':' +
            ('0' + d.getMilliseconds()).slice(-2);
        return datestring;
    }

    reloadPage(url) {
        const currentUrl = this.router.url;
        if (!currentUrl.includes(url)) {
            this.router.navigate(url);
        } else {
            window.location.reload();
        }


    }
}
